import { Empty, type EmptyStateConfig } from './Empty';

export const renderEmptyState = (empty?: EmptyStateConfig) => (
  <Empty
    title={empty?.title}
    description={empty?.subtitle}
    icon={empty?.icon}
    action={empty?.action}
  />
);
